import * as React from 'react';
import { Theme, withStyles, WithStyles, createStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import InfoListItem from './InfoListItem';
import { localizations } from '../../localization/localization';

const styles = (theme: Theme) => createStyles({
  videoContainer: {
    paddingTop: '4.375em',
    flex: 1,
    [theme.breakpoints.down('sm')]: {
      padding: '3em',
    }
  },
  videoContainerMobile: {
    paddingTop: '2.375em',
    flex: 1,
    [theme.breakpoints.down('sm')]: {
      padding: '3em',
    }
  },
  videoBox: {
    backgroundColor: '#033349',
    padding: '0.0625em',
    paddingLeft: '5em',
    paddingRight: '0.25em',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center'
  },
  videoBoxMobile: {
    backgroundColor: '#033349',
    alignItems: 'center',
    paddingTop: '0.375em',
    paddingBottom: '0.375em',
  },
  infoList: {
    justifyContent: 'flex-start',
    [theme.breakpoints.up('md')]: {
      alignItems: 'flex-end',
      paddingLeft: '4.688em',
      flex: 1
    },
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
    },
    '& > div:first-child': {
      color: 'white',
      fontSize: '2.125em',
      fontWeight: 'bold',
      lineHeight: 1.353,
      letterSpacing: '0.035em',
      marginBottom: '0.323em',
      marginTop: 30
    }
  },
  infoListMobile: {
    justifyContent: 'flex-start',
    [theme.breakpoints.up('md')]: {
      alignItems: 'flex-end',
      flex: 1
    },
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
    },
    '& > div:first-child': {
      color: 'white',
      fontSize: '2.125em',
      fontWeight: 'bold',
      lineHeight: 1.353,
      letterSpacing: '0.035em',
      marginBottom: '0.323em',
      marginTop: 30
    }
  }
});

interface InfoItemProps {
  title: string;
  content: string;
}

interface VideoContainerProps {
  items: InfoItemProps[];
  isMobile?: boolean;
}

const VideoContainer: React.SFC<WithStyles & VideoContainerProps> = ({
  classes,
  items,
  isMobile
}) => {
  return (
    <Grid item container className={isMobile === false ? classes.videoContainer : classes.videoContainerMobile}>
      <Grid item container direction="column" className={isMobile === false ? classes.videoBox : classes.videoBoxMobile}>
        <iframe width={isMobile === false ? "420" : "95%"} height={isMobile === false ? "345" : "200"} src="https://www.youtube.com/embed/gpVDK4wBbfw" allowFullScreen />
      </Grid>
      <Grid item container direction="column" className={classes.infoList}>
        <Grid item>{localizations.infoContainer.infoboxTitle2}</Grid>
        {items.map((item, index) => (
          <InfoListItem
            key={`info_list_item_${index}`}
            title={item.title}
            content={item.content}
          />
        ))}
      </Grid>
    </Grid>
  );
}

export default withStyles(styles)(VideoContainer);



// WEBPACK FOOTER //
// ./src/landingPage/components/VideoContainer.tsx